export default "__VITE_ASSET__CqYwTeDO__"